import React, { useState } from "react";
import {
  Container, Paper, Card, CardContent, Typography, Grid, Box, Stack, Autocomplete, TextField,
  Button, IconButton, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';

const customers = [
  { id: 1, name: "Rahim", mobile_no: "017xxxxxxx" },
  { id: 2, name: "Karim", mobile_no: "018xxxxxxx" },
];
const products = [
  { id: 1, name: "Paracetamol", pack_size: "10x10", measurementUnit: "Tablet" },
  { id: 2, name: "Amoxicillin", pack_size: "10x10", measurementUnit: "Capsule" },
];
const columns = [
  "Name of Product",
  "Pack Size",
  "Quantity",
  "Sample",
  "Bonus",
  "Trade Price",
  "Total Price",
];

export default function SalesReportPage() {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [tableRows, setTableRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleSearch = (e) => {
    e.preventDefault();
    // API Call here
    setTableRows([
      {
        product_name: "Paracetamol",
        pack_size: "10x10 Tablet",
        quantity: 50,
        sample_qty: 5,
        bonus_qty: 2,
        sale_unit_price: 100,
        total_price: 5000,
      },
    ]);
  };

  const handleClearProduct = () => setSelectedProduct(null);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Card elevation={4}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" color="primary" mb={2}>
            Sales Report Search
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <form onSubmit={handleSearch}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={2}
              alignItems="center"
              sx={{ mb: 3 }}
            >
              {/* Select Customer */}
              <Autocomplete
                options={customers}
                getOptionLabel={opt => `${opt.name} ${opt.mobile_no}`}
                value={selectedCustomer}
                onChange={(e, v) => setSelectedCustomer(v)}
                renderInput={params => (
                  <TextField {...params} label="Select Customer" variant="outlined" />
                )}
                sx={{ minWidth: 220, maxWidth: 300 }}
              />
              {/* Select Product */}
              <Autocomplete
                options={products}
                getOptionLabel={opt => `${opt.name} ${opt.pack_size} ${opt.measurementUnit}`}
                value={selectedProduct}
                onChange={(e, v) => setSelectedProduct(v)}
                renderInput={params => (
                  <TextField {...params} label="Select Product" variant="outlined" />
                )}
                sx={{ minWidth: 220, maxWidth: 300 }}
              />
              {/* Clear Button */}
              <IconButton
                color="error"
                onClick={handleClearProduct}
                sx={{
                  border: "1px solid #ddd",
                  background: "#fff",
                  "&:hover": { background: "#f9ecec" },
                  height: 56,
                  width: 56,
                }}
                title="Clear Product Selection"
              >
                <ClearIcon />
              </IconButton>
              {/* From Date */}
              <TextField
                label="From Date"
                type="date"
                value={fromDate}
                onChange={e => setFromDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 140, maxWidth: 180 }}
              />
              {/* To Date */}
              <TextField
                label="To Date"
                type="date"
                value={toDate}
                onChange={e => setToDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 140, maxWidth: 180 }}
              />
              {/* Search Button */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<SearchIcon />}
                sx={{
                  height: 56,
                  fontWeight: "bold",
                  fontSize: "1rem",
                  px: 3,
                }}
              >
                Search
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
      {/* Result Table */}
      <Paper sx={{ mt: 4 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {columns.map(col => (
                  <TableCell
                    key={col}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      fontSize: "1.05rem",
                      background: "#f7f7f7",
                    }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center" sx={{ color: "red" }}>
                    No record found
                  </TableCell>
                </TableRow>
              ) : (
                tableRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell align="center">{row.product_name}</TableCell>
                      <TableCell align="center">{row.pack_size}</TableCell>
                      <TableCell align="center">{row.quantity}</TableCell>
                      <TableCell align="center">{row.sample_qty}</TableCell>
                      <TableCell align="center">{row.bonus_qty}</TableCell>
                      <TableCell align="center">{row.sale_unit_price}</TableCell>
                      <TableCell align="center">{row.total_price}</TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={tableRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={e => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>
    </Container>
  );
}